var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Caret Right",
    clipPath: "url(#clip0_0_11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M4.3978 19.7427C4.07967 19.4101 4.0914 18.8826 4.42398 18.5645L13.3777 10L4.42398 1.43554C4.0914 1.11741 4.07967 0.589903 4.3978 0.257315C4.71593 -0.075271 5.24343 -0.0869933 5.57602 0.231133L15.1594 9.3978C15.3237 9.55501 15.4167 9.77256 15.4167 10C15.4167 10.2274 15.3237 10.445 15.1594 10.6022L5.57602 19.7689C5.24343 20.087 4.71593 20.0753 4.3978 19.7427Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default __webpack_public_path__ + "static/media/CaretRight.f61ad5292232c03a27237d6cc9383136.svg";
export { ForwardRef as ReactComponent };